export default __webpack_public_path__ + "static/media/cv.3acf11b0.svg";